/**
 * Used to exclude certain elements when using `getSelectedBlockComponentsByRange`.
 */
export const RANGE_QUERY_EXCLUDE_ATTR = 'data-range-query-exclude';

/**
 * Used to mark certain elements so that they are excluded when synchronizing the native range and text selection (such as database block).
 */
export const RANGE_SYNC_EXCLUDE_ATTR = 'data-range-sync-exclude';
